import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, IBaseApiListResponse, ITurnoverApiListResponse, ITurnoverEventApiListResponse } from '@/types';

export const selection = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ITurnoverApiListResponse>> => {
    return axios.get('/api/stats/turnover/selection', { ...config, params });
};

export const selectionDetail = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IBaseApiListResponse>> => {
    return axios.get('/api/stats/turnover/selectionDetail', { ...config, params });
};

export const game = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ITurnoverEventApiListResponse>> => {
    return axios.get('/api/stats/turnover/game', { ...config, params });
};

export const gameDetail = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IBaseApiListResponse>> => {
    return axios.get('/api/stats/turnover/gameDetail', { ...config, params });
};
